import { Controller } from "@hotwired/stimulus"

import jQuery from 'jquery'
let $ = window.$ = window.jQuery = jQuery


export default class extends Controller {
  follow(event) {
   
    // 取得 CSRF Token
    var token = $('meta[name="csrf-token"]').attr('content');

    // 取得要跟隨的對象 uid
    var uid = event.params['id'];
    var nickname = event.params['nickname'];
    var following = event.params['following'];

    // 使用 ajax post 發送跟隨請求
    $.ajax({
		url: "/users/follow",
		type: "POST",
		xhrFields: {
		  	withCredentials: true
		},
		data: { 
			authenticity_token: token, 
            uid: uid
		},
		success: function(data) {
			// 跟隨成功後，將按鈕變成取消跟隨
    
            
            if(following === "true"){
                $("#follow_btn").html("追蹤");
                // 變更按鈕的參數
                $("#follow_btn").attr("data-user-following-param", "false");
                following = "false";
                alert(following);   
            }else{
                $("#follow_btn").html("取消追蹤"+nickname);
                $("#follow_btn").attr("data-user-following-param", "true");
                following = "true";
            }
		},
		error: function(jqXHR, textStatus, errorThrown) {
		  	alert(textStatus);	// 錯誤處理
		}
	});

  }

  
}